import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { DEMO_MODE } from "../lib/config";
import { api } from "../lib/api";
import type { AuditEvent } from "../types";

export function AuditPage() {
  const [filterAction, setFilterAction] = useState<string>("");
  const { data, isLoading } = useQuery({
    queryKey: ["audit", filterAction],
    queryFn: async (): Promise<AuditEvent[]> => {
      if (DEMO_MODE) return [];
      const qs = filterAction ? `?action=${encodeURIComponent(filterAction)}` : "";
      return await api.get<AuditEvent[]>(`/audit/events${qs}`);
    },
  });

  return (
    <div className="page">
      <div className="page__header">
        <div>
          <h1 className="page__title">Audit log</h1>
          <p className="page__sub">
            Every PHI interaction is recorded here. Read-only — entries cannot be edited or deleted.
          </p>
        </div>
        <select
          className="form__select"
          style={{ maxWidth: 220 }}
          value={filterAction}
          onChange={(e) => setFilterAction(e.target.value)}
        >
          <option value="">All actions</option>
          <option value="copy">Copy</option>
          <option value="reveal">Reveal SSN</option>
          <option value="submit_outcome">Outcome submitted</option>
          <option value="lock">Lock</option>
          <option value="unlock">Unlock</option>
          <option value="login">Login</option>
        </select>
      </div>

      {isLoading && <div className="empty">Loading…</div>}
      {!isLoading && DEMO_MODE && (
        <div className="empty">Audit log is available once the API is reachable.</div>
      )}
      {!isLoading && !DEMO_MODE && (!data || data.length === 0) && (
        <div className="empty">No events.</div>
      )}
      {!isLoading && data && data.length > 0 && (
        <table className="table">
          <thead>
            <tr>
              <th>Time</th>
              <th>Staff</th>
              <th>Action</th>
              <th>Field</th>
              <th>Patient</th>
              <th>Session</th>
              <th>IP</th>
            </tr>
          </thead>
          <tbody>
            {data.map((e) => (
              <tr key={e.id}>
                <td className="mono">{new Date(e.timestamp).toLocaleString()}</td>
                <td>{e.staffEmail}</td>
                <td>{e.action}</td>
                <td className="mono">{e.field ?? "—"}</td>
                <td className="mono">{e.patientId ?? "—"}</td>
                <td className="mono">{e.sessionId ?? "—"}</td>
                <td className="mono">{e.ip ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
